module.exports = __webpack_public_path__ + "img/a9afcdd.jpg";